import BaseLayer from "./BaseLayer";
import {plotStitchGraphHelper, plotStitchGraphStartPositions} from "../utils/map_utils";

class StitchRound1Graphv2 extends BaseLayer {

    id = "stitchRound1Graphv2";
    label = "Path";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPathR1, stitchStartPosR1} = this.props;
        plotStitchGraphStartPositions(stitchStartPosR1, this.props.slide, this.layer.getSource());
        plotStitchGraphHelper(stitchPathR1, this.props.slide, this.layer.getSource());
        resolve();
    });
}

export default StitchRound1Graphv2;
